import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';

type EhrSettings = Record<string, any>;

type GetOrganizationEhrSettingsResponse = {
  ehr_settings: EhrSettings;
};

export const useGetOrganizationEhrSettings = () => {
  const { data, ...rest } = useQuery({
    queryKey: ['organizationEhrSettings'],
    queryFn: () =>
      api
        .get<GetOrganizationEhrSettingsResponse>(
          '/v2/organization/ehr_settings'
        )
        .then((res) => res.data),
  });

  return {
    ehrSettings: data?.ehr_settings,
    ...rest,
  };
};
